import { useEffect, useState } from 'react';

const useFloatingLabel = (fieldValue: any) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(false);

  useEffect(() => {
    setHasValue(!!fieldValue && fieldValue.length > 0);
  }, [fieldValue]);

  const showFloatingLabel = isHovered || isFocused || hasValue;

  const handleFocus = () => setIsFocused(true);

  const handleBlur = () => setIsFocused(false);

  const handleMouseEnter = () => setIsHovered(true);

  const handleMouseLeave = () => setIsHovered(false);

  return {
    isHovered,
    isFocused,
    hasValue,
    showFloatingLabel,
    handleFocus,
    handleBlur,
    handleMouseEnter,
    handleMouseLeave,
  };
};

export default useFloatingLabel;
